import type { BodyRequest } from '@pba/utils';
import { type ApiClientResponse, apiClient, routes } from 'common/services';
import type { PollContentObjectDetailDataObject } from 'models/service';

type CreatePollRequest = { poll: Record<string, unknown> };

/**
 * @deprecated AI-generated code, not reviewed. Needs revision before further use — do not use as a reference or pattern to follow.
 */
export const createPoll = async ({ body }: BodyRequest<CreatePollRequest>) =>
  apiClient.post<PollContentObjectDetailDataObject, ApiClientResponse<PollContentObjectDetailDataObject>>(
    routes.polls.create,
    body,
  );
